// Module
var code = "<div class=\"block height-100\"> <h2>Details of Sync</h2> <div id=\"syncActions\" class=\"block\"></div> <div id=\"syncOverall\" class=\"block\"></div> <div id=\"syncModules\" class=\"block\"></div> <div id=\"syncErrors\" class=\"block\"></div> <div id=\"syncSteps\" class=\"block\"></div> <div class=\"block\">&nbsp;</div> </div> ";
// Exports
export default code;